import { getUserToken } from '../../../../helpers/authUtils';
import { InitialPublicationCheckComplete, GetNotifications } from "../";

// As this is a thunk, it is a function which returns a function.
const loadNotifications_thunk = () => {
    return (dispatch, getState) => {
        const currentState = getState();
        const notificationsCurrentlyLoading = currentState.Notifications.loading;

        if (notificationsCurrentlyLoading) {
            return;
        }

        if (!currentState.Notifications.initialPublicationCheckDone) {
            checkForPublicationChanges(dispatch);
        } else {
            dispatch(GetNotifications());
        }
    };
};

const checkForPublicationChanges = (dispatch) => {
    //check for publications once after new login
    let urlCheck = '/portal/Documents/CheckPublicationChanges';
    let content = {
        check: true
    };
    
    let options = {
        ...{
            method: 'POST',
            body: content,
            headers: {
                'Content-Type': 'application/json',
                'accept': 'application/json',
                'Authorization': 'Bearer ' + getUserToken()
            }
        }
    };
    
    fetch(urlCheck, options)
        .then(response => {
            if (response.ok) {
                //note expecting non empty body
                return response.json();
            }
            else {
                throw new Error(response);
            }
        })
        .then(data => {
            dispatch(InitialPublicationCheckComplete());
            dispatch(GetNotifications());
        })
        .catch(error => {
            dispatch(GetNotifications());
        });
};

export default loadNotifications_thunk;